@CharacterCounter =
  textareaSelector: '[data-behavior=character-count]'

  init: ->
    @bindEvents()
    @updateAllCounters()

  updateAllCounters: ->
    $(@textareaSelector).each (i, e) =>
      @updateCounter($(e))

  updateCounter: (textarea) =>
    updateId  = textarea.data('count-id')
    min       = parseInt(textarea.attr('minlength') || 0)
    max       = parseInt(textarea.attr('maxlength') || 280)
    textareaVal = textarea.val()
    newLines = textareaVal.match(/(\r\n|\n|\r)/g)
    addition = 0
    if (newLines != null)
      addition = newLines.length
    remaining = max - (textareaVal.length + addition)
    $("[data-id=#{updateId}]").html(remaining)

  stripNewlinesOnPaste: (textarea) ->
    # To get the actual pasted input, we have to wait for the paste event to finish
    # Then we can replace any newline characters with a space.
    setTimeout( () ->
      textareaVal = textarea.val()
      withoutNewlines = textareaVal.replace(/(\r\n|\n|\r)/gm," ")
      console.log withoutNewlines
      textarea.val(withoutNewlines)
    , 0)

  bindEvents: ->
    $('body').on "behavior:character-count", (event) ->
      $(textareaSelector).trigger("keyup")

    $('body').on "keyup", @textareaSelector, (event) =>
      textarea  = $(event.target)
      @updateCounter(textarea)

    $('body').on "keydown", @textareaSelector, (event) ->
      textarea = $(event.target)
      if textarea.data("noNewlines") == true
        if event.keyCode == 13
          return false

    $('body').on "paste", @textareaSelector, (event) =>
      textarea = $(event.target)
      if textarea.data("noNewlines") == true
        @stripNewlinesOnPaste(textarea)

CharacterCounter = @CharacterCounter
global.CharacterCounter = @CharacterCounter